export default {
  en: {
    title: 'Conversation settings',
    loadError: 'Couldn’t load settings. Try again.',
    speedRelaxed: 'Relaxed',
    speedNormal: 'Normal',
    speedFast: 'Fast',
    speechPace: 'Speech pace',
    level: 'Level',
    autoCorrect: 'Auto-correction',
    autoCorrectHint: 'Automatically check your messages for mistakes.',
    loadingSettings: 'Loading settings',
    lockedHint: 'You can’t change settings during the level check.',
  },
  ru: {
    title: 'Настройки разговора',
    loadError: 'Не получилось загрузить настройки. Попробуй ещё раз',
    speedRelaxed: 'Спокойно',
    speedNormal: 'Обычно',
    speedFast: 'Быстро',
    speechPace: 'Темп речи',
    level: 'Уровень',
    autoCorrect: 'Автоисправление',
    autoCorrectHint: 'Автоматически проверять свои реплики на ошибки',
    loadingSettings: 'Загружаю настройки',
    lockedHint: 'Во время проверки уровня настройки изменить нельзя',
  },
  de: {
    title: 'Gesprächseinstellungen',
    loadError: 'Einstellungen konnten nicht geladen werden. Versuch es noch mal.',
    speedRelaxed: 'Ruhig',
    speedNormal: 'Normal',
    speedFast: 'Schnell',
    speechPace: 'Sprechtempo',
    level: 'Niveau',
    autoCorrect: 'Autokorrektur',
    autoCorrectHint: 'Deine Nachrichten automatisch auf Fehler prüfen.',
    loadingSettings: 'Einstellungen werden geladen',
    lockedHint: 'Während des Einstufungstests lassen sich die Einstellungen nicht ändern.',
  },
  pt: {
    title: 'Configurações da conversa',
    loadError: 'Não foi possível carregar as configurações. Tente de novo.',
    speedRelaxed: 'Calmo',
    speedNormal: 'Normal',
    speedFast: 'Rápido',
    speechPace: 'Velocidade da fala',
    level: 'Nível',
    autoCorrect: 'Correção automática',
    autoCorrectHint: 'Verificar automaticamente suas mensagens em busca de erros.',
    loadingSettings: 'Carregando configurações',
    lockedHint: 'Durante o teste de nível, não é possível mudar as configurações.',
  },
  fr: {
    title: 'Paramètres de la conversation',
    loadError: 'Impossible de charger les paramètres. Réessaie.',
    speedRelaxed: 'Tranquille',
    speedNormal: 'Normal',
    speedFast: 'Rapide',
    speechPace: 'Débit de parole',
    level: 'Niveau',
    autoCorrect: 'Correction automatique',
    autoCorrectHint: 'Vérifier automatiquement tes messages pour détecter des erreurs.',
    loadingSettings: 'Chargement des paramètres',
    lockedHint: 'Pendant le test de niveau, les paramètres ne peuvent pas être modifiés.',
  },
  es: {
    title: 'Configuración de la conversación',
    loadError: 'No se pudo cargar la configuración. Inténtalo de nuevo.',
    speedRelaxed: 'Tranquilo',
    speedNormal: 'Normal',
    speedFast: 'Rápido',
    speechPace: 'Velocidad del habla',
    level: 'Nivel',
    autoCorrect: 'Corrección automática',
    autoCorrectHint: 'Revisar automáticamente tus mensajes en busca de errores.',
    loadingSettings: 'Cargando la configuración',
    lockedHint: 'Durante la prueba de nivel no se puede cambiar la configuración.',
  },
};
